import React, {useState, useEffect} from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { DataContext } from './context/DataContext';
//import JobData from './data/jobs.json';
//import JobData from './data/ARI-2024-08-07.json';
//import LocationData from './data/locations.json';
//import LocationData from './data/locations.json';
import Home from './components/Home'
import JobDetail from './components/JobDetail';
import Locations from './conditions/Locations';
// import LocationList from './conditions/LocationList';
import { AzureContainerBlob} from "./GlobalUtilities/AzureStorage";


function App() {

  const [jobData, setJobData] = useState(null);
  const [originalJobData, setOriginalJobData] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [locationFilter, setLocationFilter] = useState([]);
  const [countryList, setCountryList] = useState();
  const [stateList, setStateList] = useState();
  const [cityList, setCityList] = useState();
  const [categoryList, setCategoryList] = useState();
  const [divisionList, setDivisionList] = useState();
  const [statusList, setStatusList] = useState();
  const [mapReset, setMapReset] = useState(false);

  

      useEffect(() => {
        const fetchData = async () => {
          try {

              //fetch jobs and locations used for cards & map from azure 
              const azureJobs = await AzureContainerBlob('careers-prd', 'jobs.json'); 

              setJobData(azureJobs);
              setOriginalJobData(azureJobs);

              const azureLocations = await AzureContainerBlob('careers-prd', 'locations.json'); 

              setLocationData(azureLocations);
              
          } catch (error) {
              console.log("Error loading job data:", error)
          }
      };

      fetchData();

    },[]);

  if(!jobData || !locationData) {
    return <p>Loading data...</p>
  }

  return (
    <div className="App">
      <DataContext.Provider value={{originalJobData,jobData, setJobData, locationFilter, setLocationFilter, locationData, setLocationData, countryList, setCountryList, stateList, setStateList, cityList, setCityList, categoryList, setCategoryList, divisionList, setDivisionList, statusList, setStatusList, mapReset, setMapReset}}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/jobdetail/:id" element={<JobDetail />}></Route>
          <Route path="/operation/:webname" element={<Home />}></Route>
          <Route path="/conditions/" element={<Locations />}></Route>
        </Routes>
      </DataContext.Provider>
    </div>
  );
}

export default App;

//test
